const movies = [
    "Titanic",
    "The Shawshank Redemption",
    "The Godfather",
    "Pulp Fiction",
    "Fight Club",
    "Inception",
    "The Dark Knight",
    "Forrest Gump",
    "Goodfellas",
    "The Matrix",
    "The Lord of the Rings: The Fellowship of the Ring",
    "The Avengers",
    "Star Wars: Episode IV - A New Hope",
    "Jurassic Park",
    "Back to the Future",
    "Gladiator", "Casablanca",
    "The Lion King",
    "The Silence of the Lambs",
    "The Departed",
    "Eternal Sunshine of the Spotless Mind",
    "The Great Gatsby",
    "The Notebook",
    "The Green Mile",
    "Interstellar",
    "Gone with the Wind",
    "The Shawshank Redemption",
    "Schindler's List",
    "Braveheart",
    "The Prestige",
    "The Usual Suspects",
    "Inglourious Basterds",
    "The Dark Knight Rises",
    "The Godfather: Part II",
    "The Pianist",
    "The Princess Bride",
    "Amélie",
    "Inglourious Basterds",
    "The Social Network",
    "Inception",
    "The Grand Budapest Hotel",
    "The Revenant",
    "The Wolf of Wall Street",
    "The Departed",
    "Django Unchained",
    "The Lord of the Rings: The Return of the King",
    "The Dark Knight",
    "The Big Lebowski",
    "No Country for Old Men",
    "Pulp Fiction",
    "Reservoir Dogs",
    "Taxi Driver", 
    "Fight Club",
    "American Beauty",
    "The Silence of the Lambs",
    "Scarface",
    "The Shining",
    "A Clockwork Orange",
    "Blade Runner",
    "The Matrix",
    "The Terminator",
    "Alien",
    "Apocalypse Now",
    "Rocky",
    "Indiana Jones and the Raiders of the Lost Ark",
    "Star Wars: Episode V - The Empire Strikes Back",
    "Jaws",
    "Jurassic Park",
    "The Exorcist",
    "Psycho",
    "The Sixth Sense",
    "The Big Chill",
    "E.T.the Extra - Terrestrial",
    "Die Hard",
    "Reservoir Dogs",
    "A Few Good Men",
    "The Breakfast Club",
    "Gone Girl",
    "Casino",
    "The Departed",
    "American Psycho",
    "Inception",
    "The Truman Show",
    "American History X",
    "The Green Mile",
    "Whiplash",
    "Black Swan",
    "Drive",
    "Mad Max: Fury Road",
    "Birdman",
    "La La Land",
    "The Shape of Water",
    "Moonlight",
    "Her",
    "Manchester by the Sea",
    "The Grand Budapest Hotel",
    "Interstellar",
    "Arrival",
    "The Social Network",
    "The Revenant",
    "Moon",
    "Blade Runner 2049",
    "The Martian",
    "Gravity",
    "Ex Machina"
]

export default movies 